export default __webpack_public_path__ + "static/media/Sun.f794832a.png";